/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const TextSpaceBeforeIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Text Space Before',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <rect height="4" rx="1" ry="1" width="22" x="12" y="24" />
    <rect height="4" rx="1" ry="1" width="22" x="12" y="18" />
    <rect height="4" rx="1" ry="1" width="22" x="12" y="30" />
    <path
      d="M2 2.672a.5.5 0 0 1 .866-.341L8 8l-5.134 5.669A.5.5 0 0 1 2 13.328ZM33 2H13a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1Zm-1 10H14V4h18Z"
    />
  </svg>`;
};
